import { IsAuthenticationEnabled } from "../../Model/AuthenticationSetting"
export enum EAuthenticationAction {
	AUTHENTICATION_ENABLE_SUCCESS = "AUTHENTICATION_ENABLE_SUCCESS",
	AUTHENTICATION_ENABLE_PENDING = "AUTHENTICATION_ENABLE_PENDING",
	AUTHENTICATION_ENABLE_ERROR = "AUTHENTICATION_ENABLE_ERROR",
	AUTHENTICATION_SET_SUPPORT_MODE = "AUTHENTICATION_SET_SUPPORT_MODE",
	REDIRECT_TO_LOGIN_PAGE = "REDIRECT_TO_LOGIN_PAGE"
}

export interface AuthenticationSettingAction {
	type: EAuthenticationAction;
	authenticationEnable: IsAuthenticationEnabled;
	enableSupportMode: boolean;
	error?: any;
}

export function authenticationEnablePending() {
	return {
		type: EAuthenticationAction.AUTHENTICATION_ENABLE_PENDING
	}
}
export function authenticationEnable(isAuthenticationEnable?: IsAuthenticationEnabled) {
	return {
		type: EAuthenticationAction.AUTHENTICATION_ENABLE_SUCCESS,
		authenticationEnable: isAuthenticationEnable
	}
}
export function authenticationEnableError(error: any) {
	return {
		type: EAuthenticationAction.AUTHENTICATION_ENABLE_ERROR,
		error: error

	}
}
export function authenticationSetSupportMode(enableSupportMode: boolean) {
	return {
		type: EAuthenticationAction.AUTHENTICATION_SET_SUPPORT_MODE,
		enableSupportMode: enableSupportMode
	}
}
// Ignore redirect to login page when authentication is disabled
export function authenticationRedirectToLoginPage() {
	return {
		type: EAuthenticationAction.REDIRECT_TO_LOGIN_PAGE
	}
}
